import { useAuthStore } from '../../../stores/authStore';
import { useNotificationStats } from '../../../hooks/useNotificationStats';
import { NotificationSection } from '../../../components/settings/NotificationSection';
import { SettingsSubPage } from '../components/SettingsSubPage';

export function NotificationsPage() {
  const authBusiness = useAuthStore(s => s.business);
  const { stats, loading } = useNotificationStats(authBusiness?.id);

  return (
    <SettingsSubPage title="Notifications" description="Email preferences, auto-replies, reminders">
      <NotificationSection stats={stats} loading={loading} />
    </SettingsSubPage>
  );
}
